// extracted by mini-css-extract-plugin
module.exports = {"filterItemContainer":"SearchDropdown_filterItemContainer__3sF2B","filterType":"SearchDropdown_filterType__1Skti","closeIcon":"SearchDropdown_closeIcon__1fpNH"};